"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    alignContent: prop_types_1.default.string,
    alignItems: prop_types_1.default.string,
    alignSelf: prop_types_1.default.string,
    flex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    flexBasis: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    flexDirection: prop_types_1.default.string,
    flexFlow: prop_types_1.default.string,
    flexGrow: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    flexShrink: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    flexWrap: prop_types_1.default.string,
    justifyContent: prop_types_1.default.string,
    justifyItems: prop_types_1.default.string,
    justifySelf: prop_types_1.default.string,
    order: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    placeContent: prop_types_1.default.string,
    placeItems: prop_types_1.default.string,
    placeSelf: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const flex = {
    className: 'flx',
    cssName: 'flex',
    jsName: 'flex',
    isPrefixed: true,
    defaultUnit: ''
};
const alignItems = {
    className: 'algn-itms',
    cssName: 'align-items',
    jsName: 'alignItems',
    isPrefixed: true
};
const alignSelf = {
    className: 'algn-slf',
    cssName: 'align-self',
    jsName: 'alignSelf',
    isPrefixed: true
};
const alignContent = {
    className: 'algn-cnt',
    cssName: 'align-content',
    jsName: 'alignContent',
    isPrefixed: true
};
const justifyContent = {
    className: 'just-cnt',
    cssName: 'justify-content',
    jsName: 'justifyContent',
    isPrefixed: true
};
const justifyItems = {
    className: 'just-items',
    cssName: 'justify-items',
    jsName: 'justifyItems',
    isPrefixed: true
};
const justifySelf = {
    className: 'just-self',
    cssName: 'justify-self',
    jsName: 'justifySelf',
    isPrefixed: true
};
const flexDirection = {
    className: 'flx-drct',
    cssName: 'flex-direction',
    jsName: 'flexDirection',
    isPrefixed: true,
    safeValue: true
};
const flexWrap = {
    className: 'flx-wrap',
    cssName: 'flex-wrap',
    jsName: 'flexWrap',
    isPrefixed: true,
    safeValue: true
};
const flexGrow = {
    className: 'flx-grow',
    cssName: 'flex-grow',
    jsName: 'flexGrow',
    isPrefixed: true,
    defaultUnit: ''
};
const flexShrink = {
    className: 'flx-srnk',
    cssName: 'flex-shrink',
    jsName: 'flexShrink',
    isPrefixed: true,
    defaultUnit: ''
};
const flexBasis = {
    className: 'flx-basis',
    cssName: 'flex-basis',
    jsName: 'flexBasis',
    isPrefixed: true
};
const order = {
    className: 'order',
    cssName: 'order',
    jsName: 'order',
    isPrefixed: true,
    defaultUnit: '',
    safeValue: true
};
const flexFlow = {
    className: 'flx-flow',
    cssName: 'flex-flow',
    jsName: 'flexFlow',
    isPrefixed: true,
    defaultUnit: ''
};
const placeContent = {
    className: 'plc-cnt',
    cssName: 'place-content',
    jsName: 'placeContent'
};
const placeItems = {
    className: 'plc-items',
    cssName: 'place-items',
    jsName: 'placeItems'
};
const placeSelf = {
    className: 'plc-self',
    cssName: 'place-self',
    jsName: 'placeSelf'
};
exports.propEnhancers = {
    alignContent: (value) => get_css_1.default(alignContent, value),
    alignItems: (value) => get_css_1.default(alignItems, value),
    alignSelf: (value) => get_css_1.default(alignSelf, value),
    flex: (value) => get_css_1.default(flex, value),
    flexBasis: (value) => get_css_1.default(flexBasis, value),
    flexDirection: (value) => get_css_1.default(flexDirection, value),
    flexFlow: (value) => get_css_1.default(flexFlow, value),
    flexGrow: (value) => get_css_1.default(flexGrow, value),
    flexShrink: (value) => get_css_1.default(flexShrink, value),
    flexWrap: (value) => get_css_1.default(flexWrap, value),
    justifyContent: (value) => get_css_1.default(justifyContent, value),
    justifyItems: (value) => get_css_1.default(justifyItems, value),
    justifySelf: (value) => get_css_1.default(justifySelf, value),
    order: (value) => get_css_1.default(order, value),
    placeContent: (value) => get_css_1.default(placeContent, value),
    placeItems: (value) => get_css_1.default(placeItems, value),
    placeSelf: (value) => get_css_1.default(placeSelf, value)
};
//# sourceMappingURL=data:application/json;base64,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